/**
 * Cierre de todas las sesiones de un usuario por un administrador.
 *
 * Cierra las sesiones del PORTAL (y con ellas el acceso a las apps del gateway);
 * no desactiva la cuenta: si el usuario sigue habilitado en Entra ID puede volver
 * a entrar. El CSRF lo añade `api/client`.
 */

import { useMutation } from '@tanstack/react-query';

import { api, ApiError } from '@/api/client';

export interface RevokeSessionsResult {
  /** Sesiones que seguían abiertas y se han cerrado. */
  revoked: number;
}

/** La variable de la mutación es el id local del usuario (`users.id`). */
export function useRevokeUserSessions() {
  return useMutation<RevokeSessionsResult, ApiError, number>({
    mutationFn: (userId) =>
      api<RevokeSessionsResult>(`/api/admin/users/${userId}/sessions`, { method: 'DELETE' }),
  });
}
